<template>
  <div class="card">
    <div class="card-name">{{$t('authorization.verifyPhoneNumber')}}</div>
    <div class="card-content">
      <div v-if="!smsRepeat" class="card-text">
        <p>
          {{ infoMessage }}
        </p>
      </div>
      <el-form v-if="!smsRepeat">
        <el-form-item :label="$t('authorization.confirmationCode')">
          <CodeConfirmationInput @code-changed="codeChanged" />
        </el-form-item>

        <div class="card-text" style="margin-bottom: 25px;">
          <p>{{ $t('authorization.resentSMS') }} {{ timeLeft }}</p>
        </div>
        <el-form-item>
          <el-row>
            <el-col :span="12">
              <button-view :width="165" @clickAction="onSubmit" id="submit-btn">
                {{$t('authorization.confirm')}}
              </button-view>
            </el-col>
            <el-col :span="12">
              <button-view
                class="white-button"
                :backgroundColor="'white'"
                :color="'#006EFF'"
                :width="165"
                @clickAction="onSubmit"
              >
                {{ $t('authorization.changeNumber') }}
              </button-view>
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>

      <el-form v-else>
        <div class="card-text">
          <p>{{$t('authorization.phoneConfirmationRequired')}}</p>
        </div>

        <el-form-item>
          <button-view :width="345" @clickAction="sendCode"
            >{{$t('authorization.sendSMSWithCode')}}
          </button-view>
        </el-form-item>
      </el-form>
    </div>
    <div class="card-footer">
      <div class="card-text">
        <p>
          {{$t('authorization.alreadyRegistered')}}
          <router-link :to="{ name: 'Login' }" style=" text-decoration: none;"
            ><span class="enter-route">{{ $t('authorization.signIn') }}</span></router-link
          >
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { ElMessage } from "element-plus";
import CodeConfirmationInput from "@/components/FormInput/CodeConfirmationInput";
import { mapMutations } from "vuex";
import buttonView from "@/components/Common/UI/buttonView.vue";
export default {
  name: "CodeConfirmation",

  props: {
    infoMessage: String,
    getDataCallback: Function,
    refreshCodeCallback: Function,
    confirmCodeCallback: Function,
  },
  data() {
    return {
      timer: null,
      code: "",
      seconds: 0,
    };
  },
  methods: {
    ...mapMutations("context", ["setProfile", "setJwtToken"]),
    codeChanged(code) {
      this.code = code;
    },

    async onSubmit() {
      try {
        await this.confirmCodeCallback(this.code);
      } catch (error) {
        if (error.response) ElMessage.error(error.response.data);
        else ElMessage.error(this.$t('common.internalError'));
      }
    },
    async sendCode() {
      let data = await this.refreshCodeCallback();
      this.seconds = data.secondsLeft;
    },
    async getData() {
      let data = await this.getDataCallback();
      this.seconds = data.secondsLeft;
      this.startTimer();
    },
    startTimer() {
      this.timer = setInterval(() => {
        this.seconds--;
      }, 1000);
    },
  },
  computed: {
    timeLeft: function() {
      if (this.seconds <= 0) return "00:00";
      let minutes = Math.floor(this.seconds / 60);
      let seconds = Math.floor(this.seconds % 60);
      const friendly = (num) => (num <= 9 ? `0${num}` : num);
      return `${friendly(minutes)}:${friendly(seconds)}`;
    },
    smsRepeat: function() {
      return this.seconds <= 0;
    },
  },
  async created() {
    await this.getData();
  },
  components: {
    CodeConfirmationInput,
    buttonView,
  },
};
</script>

<style scoped>
.card-content {
  padding-bottom: 0px;
}
.sms-confirmation-info {
  width: 100%;
}
.sms-confirmation-info.above {
  padding: 0 !important;
}
</style>
